/* eslint-disable no-unused-vars */
import React from 'react';
import _ from 'underscore';
import { Radio } from './controls';
import type { IChoiceGroupState } from './types';

export interface IRadioGroupProps<T = any> {
  checked?: T;
  getItemId?: (item: T, index: number) => string;
  getItemValue?: (item: T, index: number) => string;
  items: T[];
  // eslint-disable-next-line react/no-unused-prop-types
  name?: string | null;
  onChange: (item: T) => void;
  renderItem?: (item: T, index: number) => React.ReactNode;
  className?: string | null;
  disabled?: boolean;
}

export type IRadioGroupState = IChoiceGroupState;

export class RadioGroup<T = any> extends React.PureComponent<IRadioGroupProps<T>, IRadioGroupState> {
  static defaultProps: Partial<IRadioGroupProps<any>> = {
    checked: null,
    getItemId: (item: any, index: number) => String(index),
    getItemValue: undefined,
    name: null,
    renderItem: () => null,
    className: null,
    disabled: false,
  };

  static getDerivedStateFromProps(nextProps: IRadioGroupProps<any>, prevState: IRadioGroupState): IRadioGroupState {
    return {
      name: nextProps.name || prevState.name || _.uniqueId('radio-group-'),
    };
  }

  constructor(props: IRadioGroupProps<T>) {
    super(props);
    this.state = {};
  }

  render() {
    const getItemValue = this.props.getItemValue || this.props.getItemId;

    return (
      <>
        {this.props.items.map((item: T, index: number) => {
          const id = this.props.getItemId!(item, index);
          const onChange = () => {
            this.props.onChange(item);
          };

          return (

            <Radio
              key={id}
              id={`${this.state.name}-${id}`}
              className={this.props.className}
              checked={this.props.checked === item}
              name={this.state.name}
              onChange={onChange}
              value={getItemValue!(item, index)}
              disabled={this.props.disabled}
            >
              {this.props.renderItem ? this.props.renderItem(item, index) : null}
            </Radio>
          );
        })}
      </>
    );
  }
}
